export default __webpack_public_path__ + "static/media/ACP PLANO PDF.15ad2ef5.pdf";